import React, { useEffect, useState } from "react";
import {
  checkEmptyObject,
  generateUUID,
  isObject,
  removeProperties
} from "../../../services";
import { MultiLevelSelector } from "../MultiLevelSelector";
import styles from "./styles.scss";

const SearchLocation = props => {
  const {
    child,
    dataSource,
    module,
    category,
    isSingleElement,
    isMultiRows,
    className,
    wrapClassName,
    value,
    showPlaceholder,
    isColumn,
    hasAnyValue,
    searchPage,
    getPopupContainer
  } = props;


  const [children, setChildren] = useState([]);
  const [childFields, setChildFields] = useState([]);

  useEffect(() => {
    const { isSingleElement, child, value } = props;

    if (isSingleElement) {
      setChildren([{ id: generateUUID() }]);
    } else if (!checkEmptyObject(value)) {
      generateMinimumControls();
    } else {
      getChildFields(child);
    }

    injectSingleValue(value);
  }, []);

  useEffect(() => {
    if (checkEmptyObject(props.value)) {
      injectSingleValue(props.value);
    }
  }, [JSON.stringify(value)]);

  const generateMinimumControls = () => {
    const { minimum } = props;
    const childs = [];
    for (let i = 0; i < minimum; i += 1) {
      childs.push({ id: generateUUID() });
    }
    setChildren(childs);
  };

  const getChildFields = child => {
    const localChildFields = [];
    localChildFields.push(child.field);

    if (child.child) {
      getChildFields(child.child);

      setChildFields(localChildFields);
    }
  };

  const handleChildValueChange = (childValue, childKey) => {
    const child = children.find(c => c.id === childKey);
    child.value = childValue;

    emitChangeValue();
  };

  const injectSingleValue = value => {
    if (checkEmptyObject(value) && children.length === 0) {
      isObject(value) &&
        Object.keys(value).forEach(key => {
          value[key].forEach(v => {
            const singleValue = {};
            singleValue[key] = v;

            setChildren([{ id: generateUUID(), singleValue }]);
          });
        });
    }
  };

  const emitChangeValue = () => {
    const { onChange, value:oldVal } = props;
    const value = {};

    children.forEach(c => {
      const childValue = c.value || c.singleValue;

      if (childValue) {
        isObject(childValue) &&
          Object.keys(childValue).forEach(key => {
            const index = childFields.indexOf(key);
            const childField = childFields[index + 1];

            if (!childValue[childField]) {
              const childId = childValue[key];

              if (value[key]) {
                if (!value[key].find(id => id === childId)) {
                  value[key].push(childId);
                }
              } else {
                value[key] = [childId];
              }
            }
          });
      }
    });

    const newLvl1Val = value["categoryLv1Ids"] ? value["categoryLv1Ids"][0] : null;
    const newLvl2Val = value["categoryLv2Ids"] ? value["categoryLv2Ids"][0] : null

    // first dropdown change 
    if (newLvl1Val && (!newLvl2Val)) {
      onChange(removeProperties(value, "categoryLv2Ids"));
    }
    // second dropdown change 
    else if(newLvl2Val) {
      onChange(removeProperties(value, "categoryLv1Ids"));
    }
    // remove filters || category is NOT initially defined
    else{
      onChange(checkEmptyObject(value) ? {
        categoryLv1Ids: undefined,
        categoryLv2Ids: undefined
      } : value);
    }
    
  };

  return (
    <div className={wrapClassName}>
      {children.map(c => (
        <div
          key={c.id}
          className={`${className} ${styles.control} ${isSingleElement ? styles.fullWidth : null
            }`}
        >
          <MultiLevelSelector
            child={child}
            dataSource={dataSource}
            module={module}
            category={category}
            value={c.value}
            singleValue={c.singleValue}
            parentId={c.id}
            onChange={handleChildValueChange}
            selectorClassName={!isMultiRows ? null : styles.selector}
            isMultiRows={isMultiRows}
            className={!isMultiRows ? null : styles.multiRowSelector}
            showAllLevel={!searchPage} // hide children field options if parent is not selected
            showPlaceholder={showPlaceholder}
            isColumn={isColumn}
            hasAnyValue={hasAnyValue}
            getPopupContainer={getPopupContainer}
            showPopular
          />
        </div>
      ))}
    </div>
  );
};

SearchLocation.defaultProps = {
  title: "",
  isSingleElement: false,
  isMultiRows: false,
  onChange: () => null,
  className: "",
  minimum: 0,
  addMoreIconName: "plus",
  wrapClassName: ""
};

export default SearchLocation;



// WEBPACK FOOTER //
// ./src/components/FormControls/SearchLocation/SearchLocation.tsx